import script from "./SiswaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SiswaPage.vue?vue&type=script&setup=true&lang=js"

import "../assets/style/siswa.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__